import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CollapseData from "../components/CollapseData";
import TitleHeading from "../components/TitleHeading";
import SEOComponent from "../components/SEOComponent";
import Reveal from "../components/animations/Reveal";
import { replaceStringWithShandeChildAmount } from "../helpers/dataHelper";
import { getFaqObject } from "../helpers/StaticData/faqData";

function FAQ() {
    const faqData = getFaqObject();
    const {t} = useTranslation();
    return (
        <>
        <SEOComponent
            title="FAQ"
            description="Frequently asked questions about Shan De Children's Welfare Home in Johor Bahru: adoption, sponsorship, visiting the center, donations, receipts, and how to send a child to our care."
            keywords="FAQ, frequently asked questions, adoption, sponsorship, visit orphanage, donate, donation receipt, send child to care, charity questions"
            url="/faq"
        />
        <TitleHeading
        title = {t("faq")}
        className = "text-center pt-5"
        />
        <CollapseData
        data = {faqData}
        />
        <section className="landing-cta">
            <Reveal className="container" stagger={0.1}>
                <div className="landing-cta-eyebrow" data-reveal>{t("contactUs")}</div>
                <h2 className="landing-cta-title" data-reveal>{t("ctaTitle")}</h2>
                <p className="landing-cta-desc" data-reveal>{replaceStringWithShandeChildAmount(t("ctaDescription"))}</p>
                <div className="landing-cta-actions" data-reveal>
                    <Link className="landing-btn landing-btn-dark" to="/donate">{t("ctaDonate")}</Link>
                    <Link className="landing-btn landing-btn-ghost" to="/contactUs">{t("contactUs")}</Link>
                </div>
                <div className="landing-cta-meta" data-reveal>{t("ctaMeta")}</div>
            </Reveal>
        </section>
        </>
    )
}
export default FAQ;
